import {
  CardContent,
  Grid,
  ListItem,
  ListItemText,
  Typography,
  useEventCallback,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { PmiCard } from 'shell/components/shared/card';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import PmiTitle from 'shell/components/shared/title';
import { SubscriptionBirth, SubscriptionAire } from 'shell/authorizations/subscription';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import SubscriptionAireBornMenu from './subscription-aire-born-menu';
import SubscriptionAireTransferMenu from './subscription-aire-transfer-menu';
import SubscriptionAireCitizenshipMenu from './subscription-aire-citizenship-menu';

const HomePage = (): React.ReactElement => {
  const actions = useActionAuthorization({
    iscrizioneNascita: SubscriptionBirth,
    iscrizioneAireBorn: SubscriptionAire,
    iscrizioneAireTransfer: SubscriptionAire,
    iscrizioneAireCitizenship: SubscriptionAire,
  });

  const [SubscriptionAireBornSubmenuAnchor, setSubscriptionAireBornSubmenuAnchor] =
    useState<null | HTMLElement>(null);

  const [SubscriptionAireTransferSubmenuAnchor, setSubscriptionAireTransferSubmenuAnchor] =
    useState<null | HTMLElement>(null);

  const [SubscriptionAireCitizenshipSubmenuAnchor, setSubscriptionAireCitizenshipSubmenuAnchor] =
    useState<null | HTMLElement>(null);

  const isSubscriptionAireBornSubmenuVisible = Boolean(SubscriptionAireBornSubmenuAnchor);

  const isSubscriptionAireTransferSubmenuVisible = Boolean(SubscriptionAireTransferSubmenuAnchor);

  const isSubscriptionAireCitizenshipSubmenuVisible = Boolean(
    SubscriptionAireCitizenshipSubmenuAnchor
  );

  const handleSubscriptionAireBornMenuClick = useEventCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setSubscriptionAireBornSubmenuAnchor(event.currentTarget);
    }
  );

  const handleSubscriptionAireBornMenuClose = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    return setSubscriptionAireBornSubmenuAnchor(null);
  });

  const handleSubscriptionAireTransferMenuClick = useEventCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setSubscriptionAireTransferSubmenuAnchor(event.currentTarget);
    }
  );

  const handleSubscriptionAireTransferMenuClose = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    return setSubscriptionAireTransferSubmenuAnchor(null);
  });

  const handleSubscriptionAireCitizenshipMenuClick = useEventCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setSubscriptionAireCitizenshipSubmenuAnchor(event.currentTarget);
    }
  );

  const handleSubscriptionAireCitizenshipMenuClose = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    return setSubscriptionAireCitizenshipSubmenuAnchor(null);
  });

  return (
    <Fragment>
      <Breadcrumbs items={CommonSubscriptionCrumbs} />
      <PmiTitle title="Iscrizioni" paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area su cui iniziare ad operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {actions.iscrizioneNascita ? (
          <Grid item xs={12} md={4}>
            <Link to="/iscrizioni/famiglia" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Nascita in Famiglia" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.iscrizioneNascita ? (
          <Grid item xs={12} md={4}>
            <Link to="/iscrizioni/convivenza" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Nascita in Convivenza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.iscrizioneAireBorn ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSubscriptionAireBornMenuClick}>
              <CardContent>
                <SubscriptionAireBornMenu
                  isSubmenuVisible={isSubscriptionAireBornSubmenuVisible}
                  onClick={handleSubscriptionAireBornMenuClick}
                  onClose={handleSubscriptionAireBornMenuClose}
                  submenuAnchor={SubscriptionAireBornSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.iscrizioneAireTransfer ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSubscriptionAireTransferMenuClick}>
              <CardContent>
                <SubscriptionAireTransferMenu
                  isSubmenuVisible={isSubscriptionAireTransferSubmenuVisible}
                  onClick={handleSubscriptionAireTransferMenuClick}
                  onClose={handleSubscriptionAireTransferMenuClose}
                  submenuAnchor={SubscriptionAireTransferSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {actions.iscrizioneAireCitizenship ? (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleSubscriptionAireCitizenshipMenuClick}>
              <CardContent>
                <SubscriptionAireCitizenshipMenu
                  isSubmenuVisible={isSubscriptionAireCitizenshipSubmenuVisible}
                  onClick={handleSubscriptionAireCitizenshipMenuClick}
                  onClose={handleSubscriptionAireCitizenshipMenuClose}
                  submenuAnchor={SubscriptionAireCitizenshipSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        ) : undefined}
        {/* {actions.iscrizioneAireCitizenship ? ( */}
        {/* <Grid item xs={12} md={4}>
          <Link to="/iscrizioni/notifiche-da-stato-civile" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Registrazione S.C. - ANAGRAFE" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid> */}
        <Grid item xs={12} md={4}>
          <Link to="/iscrizioni/notifiche/ansc" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Aggiornamento anagrafe da ANSC" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
        {/* ) : undefined} */}
        {/* {actions.iscrizioneAireCitizenship ? ( */}
        <Grid item xs={12} md={4}>
          <Link to="/iscrizioni/non-residenti/nascita" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Registrazione Nascita Non Residente" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
        {/* ) : undefined} */}
        {/* {actions.iscrizioneAireCitizenship ? ( */}
        <Grid item xs={12} md={4}>
          <Link to="/iscrizioni/residenza/estero" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Iscrizione AIRE per residenza all'estero" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
        {/* ) : undefined} */}
      </Grid>
    </Fragment>
  );
};

HomePage.displayName = 'home page component';

export default HomePage;
